export default __webpack_public_path__ + "static/media/cel2.259b6590.png";